import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIncidentsEmptyState = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 159,
	height: 120,
	viewBox: "0 0 159 120",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "incidents-empty-state-linear-gradient",
			x1: .5,
			x2: .5,
			y2: 1,
			gradientUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#7284fa"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .355,
					stopColor: "#7f7ff1"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#bb65c7"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "incidents-empty-state-clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_17362",
				"data-name": "Rectangle 17362",
				width: 159,
				height: 120,
				transform: "translate(1617 483)",
				fill: "#fff",
				stroke: "#707070",
				strokeWidth: 1
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "incidents-empty-state-clip-path-2",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16863",
				"data-name": "Rectangle 16863",
				width: 18.543,
				height: 20.747,
				fill: "#d7e5f4"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "incidents-empty-state-clip-path-3",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16868",
				"data-name": "Rectangle 16868",
				width: .83,
				height: 2.782,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "incidents-empty-state-clip-path-6",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37212",
				"data-name": "Path 37212",
				d: "M0,8.528.095,24.663c1.062,8.232,10.737,14.9,14.951,17.43a3.72,3.72,0,0,0,3.949-.106c4.126-2.715,13.271-9.549,14.248-17.465l.087-15.452C33.329,3.143,24.423,0,15.819,0,7.777,0,0,2.745,0,8.528",
				transform: "translate(0 0)",
				fill: "url(#incidents-empty-state-linear-gradient)"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "incidents-empty-state-clip-path-7",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16352",
				"data-name": "Rectangle 16352",
				width: 13.121,
				height: 15.905,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "incidents-empty-state-clip-path-8",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37875",
				"data-name": "Path 37875",
				d: "M2.678,1.266A1.282,1.282,0,0,0,1.284,0,1.369,1.369,0,0,0,0,1.254,1.247,1.247,0,0,0,.67,2.432.462.462,0,0,1,.9,2.925L.6,4.6a.337.337,0,0,0,.354.393l.757-.027a.365.365,0,0,0,.353-.416l-.29-1.66a.494.494,0,0,1,.247-.5,1.323,1.323,0,0,0,.654-1.123",
				fill: "#7f7ff2"
			})
		})
	] }), /* @__PURE__ */ _jsx("g", {
		id: "Mask_Group_14587",
		"data-name": "Mask Group 14587",
		transform: "translate(-1617 -483)",
		clipPath: "url(#incidents-empty-state-clip-path)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_15101",
			"data-name": "Group 15101",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Path_39779",
				"data-name": "Path 39779",
				d: "M62.594.026c19.937.532,40.135,9.206,45.4,29.45,2.587,9.955-.809,20.516,2.431,30.339,3.276,9.933,13.671,12.836,20.793,19.484,8.6,8.026,11.168,21.943,5.431,32.246-6.191,11.12-21.159,16.674-33.326,12.368-10.5-3.717-17.608-13.2-26.907-19.25a46.086,46.086,0,0,0-27.5-7.289c-5.571.316-11.091,1.646-16.664,1.372-15.425-.758-28.005-14.267-31.2-29.055S2.37,39.447,9.383,25.979c2.694-5.173,5.836-10.255,10.326-14.049,6.565-5.547,15.3-7.8,23.713-9.879A72.48,72.48,0,0,1,62.594.026Z",
				transform: "matrix(0.643, -0.766, 0.766, 0.643, 1597.486, 552.722)",
				fill: "#7b8efa",
				opacity: .137
			}), /* @__PURE__ */ _jsx("g", {
				id: "Group_14228",
				"data-name": "Group 14228",
				transform: "translate(-5197.275 -2183.773)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_14226",
					"data-name": "Group 14226",
					transform: "translate(6788.284 2615.691)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group_14225",
						"data-name": "Group 14225",
						transform: "translate(0 0)",
						children: [/* @__PURE__ */ _jsx("g", {
							id: "Group_14192",
							"data-name": "Group 14192",
							transform: "translate(58.721 57.17)",
							children: /* @__PURE__ */ _jsxs("g", {
								id: "Group_14191",
								"data-name": "Group 14191",
								transform: "translate(0)",
								children: [/* @__PURE__ */ _jsxs("g", {
									id: "Group_14190",
									"data-name": "Group 14190",
									transform: "translate(0 0)",
									children: [
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39333",
											"data-name": "Path 39333",
											d: "M3.631,2.067,0,0V2.537L3.631,3.929Z",
											transform: "translate(57.324 38.613)",
											fill: "#b97262"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39256",
											"data-name": "Path 39256",
											d: "M389.557,50.243a4.37,4.37,0,0,1,.114-5.571c.525-.605.985-1.062,1.355-1.43,1.084-1.077,1.375-1.367,1.056-2.983a2.267,2.267,0,0,1,.431-2.231,1.872,1.872,0,0,1,1.708-.293l-.314,1.015a.847.847,0,0,0-.685.069c-.184.168-.22.618-.1,1.234.43,2.174-.2,2.8-1.349,3.942-.376.373-.8.8-1.3,1.373a3.35,3.35,0,0,0-.079,4.221Z",
											transform: "translate(-355.499 -32.959)",
											fill: "#7284fa"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39257",
											"data-name": "Path 39257",
											d: "M448.325,80.576l-1.061-.057a3.689,3.689,0,0,1,1.04-2.34,2.362,2.362,0,0,1,1.811-.559,1.414,1.414,0,0,0,1.121-.241.705.705,0,0,0,.132-.536l1.042-.208a1.753,1.753,0,0,1-.373,1.441,2.3,2.3,0,0,1-2.005.6,1.323,1.323,0,0,0-1.028.3,2.651,2.651,0,0,0-.679,1.6",
											transform: "translate(-402.706 -64.334)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39258",
											"data-name": "Path 39258",
											d: "M370.842,45.99l.557-.9a3.688,3.688,0,0,1,1.558,2.032,2.363,2.363,0,0,1-.375,1.858,1.414,1.414,0,0,0-.324,1.1.7.7,0,0,0,.407.372l-.315,1.014a1.752,1.752,0,0,1-1.088-1.016,2.3,2.3,0,0,1,.43-2.049,1.323,1.323,0,0,0,.229-1.045,2.651,2.651,0,0,0-1.079-1.361",
											transform: "translate(-341.209 -38.946)",
											fill: "#d67086"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39259",
											"data-name": "Path 39259",
											d: "M370.586,14.731l-.157-1.05a3.688,3.688,0,0,1,2.5.549,2.362,2.362,0,0,1,.91,1.662,1.414,1.414,0,0,0,.461,1.05.707.707,0,0,0,.551.022l.413.978a1.752,1.752,0,0,1-1.487-.076,2.3,2.3,0,0,1-.992-1.844,1.325,1.325,0,0,0-.5-.947,2.652,2.652,0,0,0-1.7-.345",
											transform: "translate(-340.877 -13.649)",
											fill: "#7284fa"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39260",
											"data-name": "Path 39260",
											d: "M298.016,97.344l.916.537a3.689,3.689,0,0,1-2,1.6,2.363,2.363,0,0,1-1.865-.335,1.415,1.415,0,0,0-1.107-.3.7.7,0,0,0-.363.415l-1.021-.293a1.753,1.753,0,0,1,.993-1.109,2.3,2.3,0,0,1,2.058.385,1.324,1.324,0,0,0,1.05.206,2.652,2.652,0,0,0,1.337-1.108",
											transform: "translate(-278.231 -80.998)",
											fill: "#7284fa"
										}),
										/* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_16855",
											"data-name": "Rectangle 16855",
											width: 2.822,
											height: 1.062,
											transform: "translate(36.813 16.193) rotate(-74.251)",
											fill: "#d67086"
										}),
										/* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_16856",
											"data-name": "Rectangle 16856",
											width: 2.822,
											height: 1.062,
											transform: "matrix(0.816, -0.577, 0.577, 0.816, 41.615, 12.957)",
											fill: "#7284fa"
										}),
										/* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_16857",
											"data-name": "Rectangle 16857",
											width: 2.822,
											height: 1.062,
											transform: "matrix(0.816, -0.578, 0.578, 0.816, 37.684, 33.792)",
											fill: "#7284fa"
										}),
										/* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_16858",
											"data-name": "Rectangle 16858",
											width: 1.062,
											height: 2.822,
											transform: "translate(8.326 12.484) rotate(-52.825)",
											fill: "#d67086"
										}),
										/* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_16859",
											"data-name": "Rectangle 16859",
											width: 1.062,
											height: 2.822,
											transform: "matrix(0.793, -0.609, 0.609, 0.793, 24.753, 10.221)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_16860",
											"data-name": "Rectangle 16860",
											width: 2.822,
											height: 1.062,
											transform: "translate(45.738 21.864) rotate(-28.742)",
											fill: "#d67086"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39262",
											"data-name": "Path 39262",
											d: "M447.455,31.441l-1.061-.042a3.429,3.429,0,0,1,2.886-3.013c1.027-.254,1.005-.465.956-.926a1.422,1.422,0,0,1,.482-1.437l.65.84c-.1.076-.114.123-.076.486.081.77.019,1.628-1.757,2.068a2.411,2.411,0,0,0-2.08,2.024",
											transform: "translate(-402.006 -23.606)",
											fill: "#d67086"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39264",
											"data-name": "Path 39264",
											d: "M309.421,41.055a2.566,2.566,0,0,1-.133-2.19,3.144,3.144,0,0,1,2.538-1.508,1.577,1.577,0,0,0,1.03-.438c.153-.231.048-.664-.063-1.122-.192-.79-.481-1.984.8-2.674a2.736,2.736,0,0,1,3.306.637,7.1,7.1,0,0,1,1.268,1.522l-.913.542c-.016-.026-1.58-2.614-3.158-1.765-.513.276-.485.609-.271,1.488a2.388,2.388,0,0,1-.083,1.958,2.434,2.434,0,0,1-1.742.9c-.93.154-1.536.47-1.75.912a1.5,1.5,0,0,0,.1,1.216Z",
											transform: "translate(-291.518 -29.074)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39265",
											"data-name": "Path 39265",
											d: "M273.525,194.011l7.487-.975,5.618-7.04,1.933,1.792-5.851,8.434-7.636,1.888-2.509-2.089.156-2.037Z",
											transform: "translate(-262.127 -152.336)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39266",
											"data-name": "Path 39266",
											d: "M219.373,517.6l-.256,1,1.647,1.542,1.208-.726-.7-1.27-1.647-1.542Z",
											transform: "translate(-219.117 -418.374)",
											fill: "#2f3789"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39267",
											"data-name": "Path 39267",
											d: "M225.094,363.079l-.777,3.031,1.156,10.993-5.132,16.607,1.786.936,7.48-15.84,1.519-4.707,1.518-10.223Z",
											transform: "translate(-220.101 -294.834)",
											fill: "#efbfa5"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39268",
											"data-name": "Path 39268",
											d: "M276.042,370.807,274.9,399.864l-1.813.18L270.935,381.7l-4.581-12.567Z",
											transform: "translate(-257.129 -299.709)",
											fill: "#efbfa5"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39269",
											"data-name": "Path 39269",
											d: "M300.76,525.416l.1,1.03,2.063.835.878-1.127-1.083-.932Z",
											transform: "translate(-284.815 -425.309)",
											fill: "#2f3789"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39270",
											"data-name": "Path 39270",
											d: "M227.841,248.5a114.564,114.564,0,0,0,1.081-19.72,4.245,4.245,0,0,1,1.517-3.107c.63-.14,1.178-.546,1.814-.706,4.3-1.083,6.65,2.2,8.261,5.747a101.6,101.6,0,0,1,5,13.481,75.778,75.778,0,0,1,2.865,12.308c.2,1.73.376,3.37-1.518,4.133-3.018,1.216-6.409,1.189-9.6,1.579-3.661.448-7.328.775-11.014.928-1.924.08.034-4.415,1.591-14.643",
											transform: "translate(-224.214 -183.525)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39271",
											"data-name": "Path 39271",
											d: "M255.772,225.112s.136,3.222,2.069,3.323,3.052-.814,2.95-1.933a2.625,2.625,0,0,0-.655-1.634,5.017,5.017,0,0,0-4.364.244",
											transform: "translate(-248.613 -183.294)",
											fill: "#efbfa5"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39272",
											"data-name": "Path 39272",
											d: "M350.036,83.571l-9.7-3.258,1.625,27.324L359.74,86.828Z",
											transform: "translate(-316.658 -67.293)",
											fill: "#7284fa"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39273",
											"data-name": "Path 39273",
											d: "M262.349,224.218l-5.559,6.876-10.478-4.858-2.632.575-.113,1.318.408,3.418,13.276,4.779,3.186-1.593,4.248-9.559Z",
											transform: "translate(-238.791 -183.093)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39274",
											"data-name": "Path 39274",
											d: "M270.319,188.956a2.926,2.926,0,0,1-1.551-2.029q-.035-.245-.078-.464v0h0c-.4-2.037-1.252-2.443-1.252-2.443h0a2.61,2.61,0,0,0-1.032-.519,3.021,3.021,0,0,0-.985,2.06h-.085a2.792,2.792,0,0,1,1.032.23c.249,1.759.628,4.56.642,5.377.02,1.221.309,1.243,1.13,1.511a1.79,1.79,0,0,0,1.365-.213h0c1.119-.256,2.34-2.8.814-3.508",
											transform: "translate(-256.309 -150.326)",
											fill: "#292949"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39275",
											"data-name": "Path 39275",
											d: "M256.367,192.351c-1.29-2.809-4.84-1.386-5.3,1.263-.262,1.506.536,4.124,2.335,4.149.091.254.246.735.488.86.263.135.9-.214,1.148-.341a.424.424,0,0,0,.182-.143.792.792,0,0,0-.031-.467,2.521,2.521,0,0,0,.57-.267,2.938,2.938,0,0,0,1.249-2.368,5.9,5.9,0,0,0-.639-2.685",
											transform: "translate(-244.787 -156.215)",
											fill: "#efbfa5"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39276",
											"data-name": "Path 39276",
											d: "M236.933,181.123c2.026-.73,1.447-2.315,1.447-2.315-1.66-2.383-5.212-.836-5.212-.836a4.771,4.771,0,0,0-2.2,3.234c-.032.2-.055.39-.073.569a14.928,14.928,0,0,0-.107,2.339,2.669,2.669,0,0,1-.566,1.923c-.956,1.224.212,1.764.684,2.124s-.452,3.123,3.043,2.081c2.282-1.178,2.817-1.182,1.972-2.422a12.026,12.026,0,0,1-1.557-2.478c-.589-1.676.55-3.488,2.576-4.219",
											transform: "translate(-227.755 -145.482)",
											fill: "#292949"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39277",
											"data-name": "Path 39277",
											d: "M341.05,216.009l.911-1.8,2.124-.319v2.549l-1.2.326Z",
											transform: "translate(-317.236 -174.779)",
											fill: "#efbfa5"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39285",
											"data-name": "Path 39285",
											d: "M341.491,94.406l6.568-2.414,5.5,1.847-11.766,4.8Z",
											transform: "translate(-317.591 -76.691)",
											fill: "#d7e5f4"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39286",
											"data-name": "Path 39286",
											d: "M343.9,113.469l15.086-6.028,3.633,1.231-18.513,7.7Z",
											transform: "translate(-319.528 -89.123)",
											fill: "#d7e5f4"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39287",
											"data-name": "Path 39287",
											d: "M345.474,143.035l14.465-5.76-6.3,7.374-7.839,3.4Z",
											transform: "translate(-320.796 -113.13)",
											fill: "#d7e5f4"
										}),
										/* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_16862",
											"data-name": "Rectangle 16862",
											width: 2.822,
											height: 1.062,
											transform: "translate(9.358 24.015) rotate(-3.996)",
											fill: "#d67086"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39288",
											"data-name": "Path 39288",
											d: "M343.081,107.168l12.865-5.215-1.117-.356-11.8,4.776Z",
											transform: "translate(-318.829 -84.42)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39289",
											"data-name": "Path 39289",
											d: "M344.952,121.444l18.513-7.7-1.282,1.478L345.027,122.5Z",
											transform: "translate(-320.376 -94.194)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39290",
											"data-name": "Path 39290",
											d: "M347.128,178.434l7.839-3.4s-1.231,1.506-1.246,1.458-6.516,2.862-6.516,2.862Z",
											transform: "translate(-322.127 -143.513)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("g", {
											id: "Group_14144",
											"data-name": "Group 14144",
											transform: "translate(24.285 19.844)",
											opacity: .1,
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_14143",
												"data-name": "Group 14143",
												children: /* @__PURE__ */ _jsx("g", {
													id: "Group_14142",
													"data-name": "Group 14142",
													clipPath: "url(#incidents-empty-state-clip-path-2)",
													children: /* @__PURE__ */ _jsx("path", {
														id: "Path_39291",
														"data-name": "Path 39291",
														d: "M363.338,113.743s-8.73,9.242-18.543,8.128l.192,3.261.551,9.357Z",
														transform: "translate(-344.795 -113.743)",
														fill: "#d7e5f4"
													})
												})
											})
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39292",
											"data-name": "Path 39292",
											d: "M314.494,177l.031-1.894,1.718-.368.736,1.35-.491.491-.736-.982-.275.859-.016,1.439Z",
											transform: "translate(-295.866 -143.272)",
											fill: "#7284fa"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39304",
											"data-name": "Path 39304",
											d: "M4.255,1.111,2.37,0,0,.653.03,1.93l3.992.656Z",
											transform: "translate(75.931 50.082) rotate(-14)",
											fill: "#e0cbaf"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39307",
											"data-name": "Path 39307",
											d: "M19.557,3.824C19.424,3.795,15.975,0,15.975,0L9.415,4.972H.423L0,7.511,10.9,9.627Z",
											transform: "matrix(0.946, 0.326, -0.326, 0.946, 62.191, 35.233)",
											fill: "#2f3789"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39308",
											"data-name": "Path 39308",
											d: "M586.7,331.248l-1.75,16.226,1.047,21.238,2.354.226,3.345-19.182,5.079-19.015Z",
											transform: "translate(-513.497 -268.811)",
											fill: "#292949"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39309",
											"data-name": "Path 39309",
											d: "M679.556,525.368l-1.792,1.977.635.942,3.624-1.293-.25-1.915Z",
											transform: "translate(-588.188 -425.194)",
											fill: "#2f3789"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39310",
											"data-name": "Path 39310",
											d: "M642.6,359.259l3.722,15.463,4.251,15.342,3.134-.561-2.231-16.2-.064-15.287-4.729-1.495Z",
											transform: "translate(-559.894 -289.556)",
											fill: "#292949"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39311",
											"data-name": "Path 39311",
											d: "M15.877.009S11.435,1.569,6.96,9.128C2.4,16.826,0,27.92,0,27.92s20.741,9.115,21.2,5.394c0,0,8.046-28.964-1.386-32.1A26.99,26.99,0,0,0,15.877.009",
											transform: "translate(63.732 41.327) rotate(-14)",
											fill: "#283177"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39312",
											"data-name": "Path 39312",
											d: "M14.157,0c-2.637,3.573-5.222,7.863-7.9,11.407-1.586,2.1-2.214,4.552-2.985,7.019l-2.3,7.359L0,28.895l8.815,3.228c.237-3.146.4-6.3.69-9.439.272-2.9.4-6.194,1.621-8.877C11.72,12.5,12.334,11.2,12.935,9.9c1.1-2.392,1.958-4.908,3.081-7.291A12.929,12.929,0,0,0,16.261.732Z",
											transform: "translate(66.55 40.851) rotate(-14)",
											fill: "#fff"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39313",
											"data-name": "Path 39313",
											d: "M1.508,7.61l2.182.356a11.053,11.053,0,0,0,.337-1.729c.646-.05,1.411-.18,1.679-.77a1.832,1.832,0,0,0,.122-.6L6.055,2.35a2.227,2.227,0,0,0-.036-.869A1.871,1.871,0,0,0,4.934.458a4.555,4.555,0,0,0-3.8-.082,2,2,0,0,0-.814.633,2.707,2.707,0,0,0-.32,1.55Q0,3.3,0,4.045A1.852,1.852,0,0,0,.5,5.608c.244.179.573.233.778.456.361.392.13,1.023.233,1.546",
											transform: "translate(76.9 30.968) rotate(-14)",
											fill: "#b97262"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39314",
											"data-name": "Path 39314",
											d: "M0,0,1.059,2.916,1.092.364Z",
											transform: "translate(76.218 32.438) rotate(-14)",
											fill: "#292949"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39315",
											"data-name": "Path 39315",
											d: "M.122,2.392A7.079,7.079,0,0,1,.723.827,2.2,2.2,0,0,1,3.16.069c1.94.373,4.006,0,5.69,1.157a25.069,25.069,0,0,1,3.185,1.925,2.936,2.936,0,0,1,.717,1.219A4.427,4.427,0,0,1,11.557,8.9a6.324,6.324,0,0,1-.89.662A4.745,4.745,0,0,1,8.5,10.5c.148-.622,1.229-2.418.89-3.05-.538-1-2.314-1.177-3.3-1.228-1.076-.056-2.175.423-3.225.308A3.937,3.937,0,0,1,.758,5.3,2.988,2.988,0,0,1,.122,2.392",
											transform: "translate(72.466 27.278) rotate(-14)",
											fill: "#292949"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39316",
											"data-name": "Path 39316",
											d: "M581.236,524.914l-2.173,1.284.276.965,3.722-.37.2-1.637Z",
											transform: "translate(-508.765 -425.062)",
											fill: "#2f3789"
										}),
										/* @__PURE__ */ _jsx("g", {
											id: "Group_14150",
											"data-name": "Group 14150",
											transform: "translate(75.218 49.277) rotate(-14)",
											opacity: .1,
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_14149",
												"data-name": "Group 14149",
												children: /* @__PURE__ */ _jsx("g", {
													id: "Group_14148",
													"data-name": "Group 14148",
													clipPath: "url(#incidents-empty-state-clip-path-3)",
													children: /* @__PURE__ */ _jsx("path", {
														id: "Path_39320",
														"data-name": "Path 39320",
														d: "M.83,2.716.617,0A13.071,13.071,0,0,1,0,2.782Z",
														transform: "translate(0 0)",
														fill: "#1e1e1e"
													})
												})
											})
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39331",
											"data-name": "Path 39331",
											d: "M22.324,0s-1.941.674-2.081,1.025-6.7,10.612-6.7,10.612L0,14.9l.637,3.09L13.12,16.609l4.549-.317,7.3-10.579-.242-3.722Z",
											transform: "translate(63.349 43.582) rotate(-14)",
											fill: "#2f3789"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39332",
											"data-name": "Path 39332",
											d: "M4.441,0,0,.37l.8.949,4.062.744Z",
											transform: "translate(62.891 59.669) rotate(-14)",
											fill: "#b97262"
										})
									]
								}), /* @__PURE__ */ _jsxs("g", {
									id: "Group_14193",
									"data-name": "Group 14193",
									transform: "translate(0)",
									children: [
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39333-2",
											"data-name": "Path 39333",
											d: "M3.631,2.067,0,0V2.537L3.631,3.929Z",
											transform: "translate(57.324 38.613)",
											fill: "#b97262"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39256-2",
											"data-name": "Path 39256",
											d: "M389.557,50.243a4.37,4.37,0,0,1,.114-5.571c.525-.605.985-1.062,1.355-1.43,1.084-1.077,1.375-1.367,1.056-2.983a2.267,2.267,0,0,1,.431-2.231,1.872,1.872,0,0,1,1.708-.293l-.314,1.015a.847.847,0,0,0-.685.069c-.184.168-.22.618-.1,1.234.43,2.174-.2,2.8-1.349,3.942-.376.373-.8.8-1.3,1.373a3.35,3.35,0,0,0-.079,4.221Z",
											transform: "translate(-355.499 -32.959)",
											fill: "#7284fa"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39257-2",
											"data-name": "Path 39257",
											d: "M448.325,80.576l-1.061-.057a3.689,3.689,0,0,1,1.04-2.34,2.362,2.362,0,0,1,1.811-.559,1.414,1.414,0,0,0,1.121-.241.705.705,0,0,0,.132-.536l1.042-.208a1.753,1.753,0,0,1-.373,1.441,2.3,2.3,0,0,1-2.005.6,1.323,1.323,0,0,0-1.028.3,2.651,2.651,0,0,0-.679,1.6",
											transform: "translate(-402.706 -64.334)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39258-2",
											"data-name": "Path 39258",
											d: "M370.842,45.99l.557-.9a3.688,3.688,0,0,1,1.558,2.032,2.363,2.363,0,0,1-.375,1.858,1.414,1.414,0,0,0-.324,1.1.7.7,0,0,0,.407.372l-.315,1.014a1.752,1.752,0,0,1-1.088-1.016,2.3,2.3,0,0,1,.43-2.049,1.323,1.323,0,0,0,.229-1.045,2.651,2.651,0,0,0-1.079-1.361",
											transform: "translate(-341.209 -38.946)",
											fill: "#ff809b"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39259-2",
											"data-name": "Path 39259",
											d: "M370.586,14.731l-.157-1.05a3.688,3.688,0,0,1,2.5.549,2.362,2.362,0,0,1,.91,1.662,1.414,1.414,0,0,0,.461,1.05.707.707,0,0,0,.551.022l.413.978a1.752,1.752,0,0,1-1.487-.076,2.3,2.3,0,0,1-.992-1.844,1.325,1.325,0,0,0-.5-.947,2.652,2.652,0,0,0-1.7-.345",
											transform: "translate(-340.877 -13.649)",
											fill: "#7284fa"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39260-2",
											"data-name": "Path 39260",
											d: "M298.016,97.344l.916.537a3.689,3.689,0,0,1-2,1.6,2.363,2.363,0,0,1-1.865-.335,1.415,1.415,0,0,0-1.107-.3.7.7,0,0,0-.363.415l-1.021-.293a1.753,1.753,0,0,1,.993-1.109,2.3,2.3,0,0,1,2.058.385,1.324,1.324,0,0,0,1.05.206,2.652,2.652,0,0,0,1.337-1.108",
											transform: "translate(-278.231 -80.998)",
											fill: "#7284fa"
										}),
										/* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_16855-2",
											"data-name": "Rectangle 16855",
											width: 2.822,
											height: 1.062,
											transform: "translate(36.813 16.193) rotate(-74.251)",
											fill: "#ff809b"
										}),
										/* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_16856-2",
											"data-name": "Rectangle 16856",
											width: 2.822,
											height: 1.062,
											transform: "matrix(0.816, -0.577, 0.577, 0.816, 41.615, 12.957)",
											fill: "#7284fa"
										}),
										/* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_16857-2",
											"data-name": "Rectangle 16857",
											width: 2.822,
											height: 1.062,
											transform: "matrix(0.816, -0.578, 0.578, 0.816, 37.684, 33.792)",
											fill: "#7284fa"
										}),
										/* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_16858-2",
											"data-name": "Rectangle 16858",
											width: 1.062,
											height: 2.822,
											transform: "translate(8.326 12.484) rotate(-52.825)",
											fill: "#ff809b"
										}),
										/* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_16859-2",
											"data-name": "Rectangle 16859",
											width: 1.062,
											height: 2.822,
											transform: "matrix(0.793, -0.609, 0.609, 0.793, 24.753, 10.221)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_16860-2",
											"data-name": "Rectangle 16860",
											width: 2.822,
											height: 1.062,
											transform: "translate(45.738 21.864) rotate(-28.742)",
											fill: "#ff809b"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39262-2",
											"data-name": "Path 39262",
											d: "M447.455,31.441l-1.061-.042a3.429,3.429,0,0,1,2.886-3.013c1.027-.254,1.005-.465.956-.926a1.422,1.422,0,0,1,.482-1.437l.65.84c-.1.076-.114.123-.076.486.081.77.019,1.628-1.757,2.068a2.411,2.411,0,0,0-2.08,2.024",
											transform: "translate(-402.006 -23.606)",
											fill: "#ff809b"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39264-2",
											"data-name": "Path 39264",
											d: "M309.421,41.055a2.566,2.566,0,0,1-.133-2.19,3.144,3.144,0,0,1,2.538-1.508,1.577,1.577,0,0,0,1.03-.438c.153-.231.048-.664-.063-1.122-.192-.79-.481-1.984.8-2.674a2.736,2.736,0,0,1,3.306.637,7.1,7.1,0,0,1,1.268,1.522l-.913.542c-.016-.026-1.58-2.614-3.158-1.765-.513.276-.485.609-.271,1.488a2.388,2.388,0,0,1-.083,1.958,2.434,2.434,0,0,1-1.742.9c-.93.154-1.536.47-1.75.912a1.5,1.5,0,0,0,.1,1.216Z",
											transform: "translate(-291.518 -29.074)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39265-2",
											"data-name": "Path 39265",
											d: "M273.525,194.011l7.487-.975,5.618-7.04,1.933,1.792-5.851,8.434-7.636,1.888-2.509-2.089.156-2.037Z",
											transform: "translate(-262.127 -152.336)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39266-2",
											"data-name": "Path 39266",
											d: "M219.373,517.6l-.256,1,1.647,1.542,1.208-.726-.7-1.27-1.647-1.542Z",
											transform: "translate(-219.117 -418.374)",
											fill: "#2f3789"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39267-2",
											"data-name": "Path 39267",
											d: "M225.094,363.079l-.777,3.031,1.156,10.993-5.132,16.607,1.786.936,7.48-15.84,1.519-4.707,1.518-10.223Z",
											transform: "translate(-220.101 -294.834)",
											fill: "#efbfa5"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39268-2",
											"data-name": "Path 39268",
											d: "M276.042,370.807,274.9,399.864l-1.813.18L270.935,381.7l-4.581-12.567Z",
											transform: "translate(-257.129 -299.709)",
											fill: "#efbfa5"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39269-2",
											"data-name": "Path 39269",
											d: "M300.76,525.416l.1,1.03,2.063.835.878-1.127-1.083-.932Z",
											transform: "translate(-284.815 -425.309)",
											fill: "#2f3789"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39270-2",
											"data-name": "Path 39270",
											d: "M227.841,248.5a114.564,114.564,0,0,0,1.081-19.72,4.245,4.245,0,0,1,1.517-3.107c.63-.14,1.178-.546,1.814-.706,4.3-1.083,6.65,2.2,8.261,5.747a101.6,101.6,0,0,1,5,13.481,75.778,75.778,0,0,1,2.865,12.308c.2,1.73.376,3.37-1.518,4.133-3.018,1.216-6.409,1.189-9.6,1.579-3.661.448-7.328.775-11.014.928-1.924.08.034-4.415,1.591-14.643",
											transform: "translate(-224.214 -183.525)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39271-2",
											"data-name": "Path 39271",
											d: "M255.772,225.112s.136,3.222,2.069,3.323,3.052-.814,2.95-1.933a2.625,2.625,0,0,0-.655-1.634,5.017,5.017,0,0,0-4.364.244",
											transform: "translate(-248.613 -183.294)",
											fill: "#efbfa5"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39272-2",
											"data-name": "Path 39272",
											d: "M350.036,83.571l-9.7-3.258,1.625,27.324L359.74,86.828Z",
											transform: "translate(-316.658 -67.293)",
											fill: "#7284fa"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39273-2",
											"data-name": "Path 39273",
											d: "M262.349,224.218l-5.559,6.876-10.478-4.858-2.632.575-.113,1.318.408,3.418,13.276,4.779,3.186-1.593,4.248-9.559Z",
											transform: "translate(-238.791 -183.093)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39274-2",
											"data-name": "Path 39274",
											d: "M270.319,188.956a2.926,2.926,0,0,1-1.551-2.029q-.035-.245-.078-.464v0h0c-.4-2.037-1.252-2.443-1.252-2.443h0a2.61,2.61,0,0,0-1.032-.519,3.021,3.021,0,0,0-.985,2.06h-.085a2.792,2.792,0,0,1,1.032.23c.249,1.759.628,4.56.642,5.377.02,1.221.309,1.243,1.13,1.511a1.79,1.79,0,0,0,1.365-.213h0c1.119-.256,2.34-2.8.814-3.508",
											transform: "translate(-256.309 -150.326)",
											fill: "#292949"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39275-2",
											"data-name": "Path 39275",
											d: "M256.367,192.351c-1.29-2.809-4.84-1.386-5.3,1.263-.262,1.506.536,4.124,2.335,4.149.091.254.246.735.488.86.263.135.9-.214,1.148-.341a.424.424,0,0,0,.182-.143.792.792,0,0,0-.031-.467,2.521,2.521,0,0,0,.57-.267,2.938,2.938,0,0,0,1.249-2.368,5.9,5.9,0,0,0-.639-2.685",
											transform: "translate(-244.787 -156.215)",
											fill: "#efbfa5"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39276-2",
											"data-name": "Path 39276",
											d: "M236.933,181.123c2.026-.73,1.447-2.315,1.447-2.315-1.66-2.383-5.212-.836-5.212-.836a4.771,4.771,0,0,0-2.2,3.234c-.032.2-.055.39-.073.569a14.928,14.928,0,0,0-.107,2.339,2.669,2.669,0,0,1-.566,1.923c-.956,1.224.212,1.764.684,2.124s-.452,3.123,3.043,2.081c2.282-1.178,2.817-1.182,1.972-2.422a12.026,12.026,0,0,1-1.557-2.478c-.589-1.676.55-3.488,2.576-4.219",
											transform: "translate(-227.755 -145.482)",
											fill: "#292949"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39277-2",
											"data-name": "Path 39277",
											d: "M341.05,216.009l.911-1.8,2.124-.319v2.549l-1.2.326Z",
											transform: "translate(-317.236 -174.779)",
											fill: "#efbfa5"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39285-2",
											"data-name": "Path 39285",
											d: "M341.491,94.406l6.568-2.414,5.5,1.847-11.766,4.8Z",
											transform: "translate(-317.591 -76.691)",
											fill: "#d7e5f4"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39286-2",
											"data-name": "Path 39286",
											d: "M343.9,113.469l15.086-6.028,3.633,1.231-18.513,7.7Z",
											transform: "translate(-319.528 -89.123)",
											fill: "#d7e5f4"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39287-2",
											"data-name": "Path 39287",
											d: "M345.474,143.035l14.465-5.76-6.3,7.374-7.839,3.4Z",
											transform: "translate(-320.796 -113.13)",
											fill: "#d7e5f4"
										}),
										/* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_16862-2",
											"data-name": "Rectangle 16862",
											width: 2.822,
											height: 1.062,
											transform: "translate(9.358 24.015) rotate(-3.996)",
											fill: "#ff809b"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39288-2",
											"data-name": "Path 39288",
											d: "M343.081,107.168l12.865-5.215-1.117-.356-11.8,4.776Z",
											transform: "translate(-318.829 -84.42)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39289-2",
											"data-name": "Path 39289",
											d: "M344.952,121.444l18.513-7.7-1.282,1.478L345.027,122.5Z",
											transform: "translate(-320.376 -94.194)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39290-2",
											"data-name": "Path 39290",
											d: "M347.128,178.434l7.839-3.4s-1.231,1.506-1.246,1.458-6.516,2.862-6.516,2.862Z",
											transform: "translate(-322.127 -143.513)",
											fill: "#3b3387"
										}),
										/* @__PURE__ */ _jsx("g", {
											id: "Group_14144-2",
											"data-name": "Group 14144",
											transform: "translate(24.285 19.844)",
											opacity: .1,
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_14143-2",
												"data-name": "Group 14143",
												children: /* @__PURE__ */ _jsx("g", {
													id: "Group_14142-2",
													"data-name": "Group 14142",
													clipPath: "url(#incidents-empty-state-clip-path-2)",
													children: /* @__PURE__ */ _jsx("path", {
														id: "Path_39291-2",
														"data-name": "Path 39291",
														d: "M363.338,113.743s-8.73,9.242-18.543,8.128l.192,3.261.551,9.357Z",
														transform: "translate(-344.795 -113.743)",
														fill: "#d7e5f4"
													})
												})
											})
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39292-2",
											"data-name": "Path 39292",
											d: "M314.494,177l.031-1.894,1.718-.368.736,1.35-.491.491-.736-.982-.275.859-.016,1.439Z",
											transform: "translate(-295.866 -143.272)",
											fill: "#7284fa"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39304-2",
											"data-name": "Path 39304",
											d: "M4.255,1.111,2.37,0,0,.653.03,1.93l3.992.656Z",
											transform: "translate(75.931 50.082) rotate(-14)",
											fill: "#e0cbaf"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39307-2",
											"data-name": "Path 39307",
											d: "M19.557,3.824C19.424,3.795,15.975,0,15.975,0L9.415,4.972H.423L0,7.511,10.9,9.627Z",
											transform: "matrix(0.946, 0.326, -0.326, 0.946, 62.191, 35.233)",
											fill: "#2f3789"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39308-2",
											"data-name": "Path 39308",
											d: "M586.7,331.248l-1.75,16.226,1.047,21.238,2.354.226,3.345-19.182,5.079-19.015Z",
											transform: "translate(-513.497 -268.811)",
											fill: "#292949"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39309-2",
											"data-name": "Path 39309",
											d: "M679.556,525.368l-1.792,1.977.635.942,3.624-1.293-.25-1.915Z",
											transform: "translate(-588.188 -425.194)",
											fill: "#2f3789"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39310-2",
											"data-name": "Path 39310",
											d: "M642.6,359.259l3.722,15.463,4.251,15.342,3.134-.561-2.231-16.2-.064-15.287-4.729-1.495Z",
											transform: "translate(-559.894 -289.556)",
											fill: "#292949"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39311-2",
											"data-name": "Path 39311",
											d: "M15.877.009S11.435,1.569,6.96,9.128C2.4,16.826,0,27.92,0,27.92s20.741,9.115,21.2,5.394c0,0,8.046-28.964-1.386-32.1A26.99,26.99,0,0,0,15.877.009",
											transform: "translate(63.732 41.327) rotate(-14)",
											fill: "#283177"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39312-2",
											"data-name": "Path 39312",
											d: "M14.157,0c-2.637,3.573-5.222,7.863-7.9,11.407-1.586,2.1-2.214,4.552-2.985,7.019l-2.3,7.359L0,28.895l8.815,3.228c.237-3.146.4-6.3.69-9.439.272-2.9.4-6.194,1.621-8.877C11.72,12.5,12.334,11.2,12.935,9.9c1.1-2.392,1.958-4.908,3.081-7.291A12.929,12.929,0,0,0,16.261.732Z",
											transform: "translate(66.55 40.851) rotate(-14)",
											fill: "#fff"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39313-2",
											"data-name": "Path 39313",
											d: "M1.508,7.61l2.182.356a11.053,11.053,0,0,0,.337-1.729c.646-.05,1.411-.18,1.679-.77a1.832,1.832,0,0,0,.122-.6L6.055,2.35a2.227,2.227,0,0,0-.036-.869A1.871,1.871,0,0,0,4.934.458a4.555,4.555,0,0,0-3.8-.082,2,2,0,0,0-.814.633,2.707,2.707,0,0,0-.32,1.55Q0,3.3,0,4.045A1.852,1.852,0,0,0,.5,5.608c.244.179.573.233.778.456.361.392.13,1.023.233,1.546",
											transform: "translate(76.9 30.968) rotate(-14)",
											fill: "#b97262"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39314-2",
											"data-name": "Path 39314",
											d: "M0,0,1.059,2.916,1.092.364Z",
											transform: "translate(76.218 32.438) rotate(-14)",
											fill: "#292949"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39315-2",
											"data-name": "Path 39315",
											d: "M.122,2.392A7.079,7.079,0,0,1,.723.827,2.2,2.2,0,0,1,3.16.069c1.94.373,4.006,0,5.69,1.157a25.069,25.069,0,0,1,3.185,1.925,2.936,2.936,0,0,1,.717,1.219A4.427,4.427,0,0,1,11.557,8.9a6.324,6.324,0,0,1-.89.662A4.745,4.745,0,0,1,8.5,10.5c.148-.622,1.229-2.418.89-3.05-.538-1-2.314-1.177-3.3-1.228-1.076-.056-2.175.423-3.225.308A3.937,3.937,0,0,1,.758,5.3,2.988,2.988,0,0,1,.122,2.392",
											transform: "translate(72.466 27.278) rotate(-14)",
											fill: "#292949"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39316-2",
											"data-name": "Path 39316",
											d: "M581.236,524.914l-2.173,1.284.276.965,3.722-.37.2-1.637Z",
											transform: "translate(-508.765 -425.062)",
											fill: "#2f3789"
										}),
										/* @__PURE__ */ _jsx("g", {
											id: "Group_14150-2",
											"data-name": "Group 14150",
											transform: "translate(75.218 49.277) rotate(-14)",
											opacity: .1,
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_14149-2",
												"data-name": "Group 14149",
												children: /* @__PURE__ */ _jsx("g", {
													id: "Group_14148-2",
													"data-name": "Group 14148",
													clipPath: "url(#incidents-empty-state-clip-path-3)",
													children: /* @__PURE__ */ _jsx("path", {
														id: "Path_39320-2",
														"data-name": "Path 39320",
														d: "M.83,2.716.617,0A13.071,13.071,0,0,1,0,2.782Z",
														transform: "translate(0 0)",
														fill: "#1e1e1e"
													})
												})
											})
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39331-2",
											"data-name": "Path 39331",
											d: "M22.324,0s-1.941.674-2.081,1.025-6.7,10.612-6.7,10.612L0,14.9l.637,3.09L13.12,16.609l4.549-.317,7.3-10.579-.242-3.722Z",
											transform: "translate(63.349 43.582) rotate(-14)",
											fill: "#2f3789"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_39332-2",
											"data-name": "Path 39332",
											d: "M4.441,0,0,.37l.8.949,4.062.744Z",
											transform: "translate(62.891 59.669) rotate(-14)",
											fill: "#b97262"
										})
									]
								})]
							})
						}), /* @__PURE__ */ _jsxs("g", {
							id: "Group_14224",
							"data-name": "Group 14224",
							transform: "matrix(0.995, 0.105, -0.105, 0.995, 87.168, 90.486)",
							children: [/* @__PURE__ */ _jsx("g", {
								id: "Group_13210",
								"data-name": "Group 13210",
								transform: "matrix(0.985, -0.174, 0.174, 0.985, 0, 5.788)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_12088",
									"data-name": "Group 12088",
									transform: "translate(0 0)",
									clipPath: "url(#incidents-empty-state-clip-path-6)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_15901",
										"data-name": "Rectangle 15901",
										width: 48.909,
										height: 53.18,
										transform: "translate(-17.072 8.49) rotate(-26.442)",
										fill: "url(#incidents-empty-state-linear-gradient)"
									})
								})
							}), /* @__PURE__ */ _jsx("g", {
								id: "Group_13218",
								"data-name": "Group 13218",
								transform: "matrix(0.985, -0.174, 0.174, 0.985, 11.912, 16.183)",
								style: { isolation: "isolate" },
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_13215",
									"data-name": "Group 13215",
									style: {
										mixBlendMode: "soft-light",
										isolation: "isolate"
									},
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_13214",
										"data-name": "Group 13214",
										children: /* @__PURE__ */ _jsxs("g", {
											id: "Group_13213",
											"data-name": "Group 13213",
											clipPath: "url(#incidents-empty-state-clip-path-7)",
											children: [
												/* @__PURE__ */ _jsx("path", {
													id: "Path_37873",
													"data-name": "Path 37873",
													d: "M11.8,0,1.444.092A1.426,1.426,0,0,0,0,1.478V8.111a1.337,1.337,0,0,0,1.439,1.3l10.317-.422a1.389,1.389,0,0,0,1.333-1.357L13.121,1.3A1.3,1.3,0,0,0,11.8,0",
													transform: "translate(0 6.488)",
													fill: "#fff"
												}),
												/* @__PURE__ */ _jsx("path", {
													id: "Path_37874",
													"data-name": "Path 37874",
													d: "M10.652,5.83a.552.552,0,0,1-.561-.552L10.1,3.833a2.685,2.685,0,0,0-2.689-2.66L4.029,1.14A2.747,2.747,0,0,0,1.208,3.828V5.319A.593.593,0,0,1,.6,5.9.586.586,0,0,1,0,5.324v-1.5A3.909,3.909,0,0,1,4.032,0L7.412.047a3.821,3.821,0,0,1,3.81,3.787l-.007,1.439a.565.565,0,0,1-.564.557",
													transform: "translate(1 0)",
													fill: "#fff"
												}),
												/* @__PURE__ */ _jsx("g", {
													id: "Group_13212",
													"data-name": "Group 13212",
													transform: "translate(5.359 9.026)",
													children: /* @__PURE__ */ _jsx("g", {
														id: "Group_13211",
														"data-name": "Group 13211",
														transform: "translate(0 0)",
														clipPath: "url(#incidents-empty-state-clip-path-8)",
														children: /* @__PURE__ */ _jsx("rect", {
															id: "Rectangle_16351",
															"data-name": "Rectangle 16351",
															width: 2.708,
															height: 5.048,
															transform: "translate(-0.027 -0.046)",
															fill: "#7f7ff2"
														})
													})
												})
											]
										})
									})
								})
							})]
						})]
					})
				})
			})]
		})
	})]
});
export default SvgIncidentsEmptyState;
